import React from 'react';

export const waiveTrainingPayDescription = (
  <p>
    You can’t get VA compensation for the same days you get training pay. If you
    want to keep your training pay, you’ll need to waive (or tell us you don’t
    want to get) VA compensation pay for the days you receive training pay.{' '}
    <strong>
      In general, training pay is going to be more than your compensation pay
      for any given day.
    </strong>
  </p>
);
